import type { ElementType } from '../../../stores/event-trigger/types';

export enum EventActionType {
  ButtonUpPressed = 'button_up_pressed',
  ButtonMiddlePressed = 'button_middle_pressed',
  ButtonDownPressed = 'button_down_pressed',
  ButtonHover = 'buttons_hover',
  ButtonDefault = 'buttons_default',
  Close = 'button_close_pressed',
}

export type RiveTextMapping = {
  id: string;
  value: string | number;
};

export type ActionHandler = (data?: any) => void | Promise<void>;

export type ActionHandlerMap = {
  [key in EventActionType]?: ActionHandler;
};

export enum RiveAnimationType {
  MESSAGE = 'message',
  OFFER = 'offer',
  GIFT = 'gift',
}

export type RiveAnimationBaseProps = {
  userEventTriggerId: string;
  riveFileUrl?: string;
  onElementClick?: (type: ElementType, data?: any) => void | Promise<void>;
  onClose?: () => void;
  type: RiveAnimationType;
};

export type RiveMessageAnimationProps = RiveAnimationBaseProps;

export type RiveOfferAnimationProps = RiveAnimationBaseProps & {
  packages: any[];
  packageTextMapping: any[];
};

export type RiveGiftAnimationProps = RiveAnimationBaseProps & {
  packageData: {
    gcCoin: number;
    scCoin: number;
  };
  gcTextId: string;
  scTextId: string;
};
